import { z } from 'zod';

export const TermsAndConditionsSchemas = z.any();
